var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataList',{attrs:{"title":"Департаменти","resource":"departments","disable-adding":!_vm.isAdmin,"readonly":!_vm.isAdmin,"columns":_vm.columns,"get-items-fn":_vm.getDepartments}})}
var staticRenderFns = []

export { render, staticRenderFns }